// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__BQvE6","clickedWithMouse":"MenuLabel_clickedWithMouse__iGvEu","isOpen":"MenuLabel_isOpen__1ENOm"};